import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import TrackingManagement from '../../../components/SiteAdmin/TrackingManagement/TrackingManagement';
import Loader from '../../../components/Common/Loader/Loader';
import messages from '../../../locale/messages';
class Tracking extends React.Component {

  render() {
    const { formatMessage } = this.props.intl;
    const { loading } = this.props;

    return (
      <Loader type={"page"} show={loading}>
        <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.tracking)}</h1>
        <TrackingManagement />
      </Loader>
    )
  }

}

const mapState = (state) => ({
  loading: state?.loader?.GetMapData
});

export default injectIntl(connect(mapState)(Tracking));